"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = exports.LogLevels = void 0;
exports.LogLevels = ["debug", "info", "warn", "error", "fatal"];
var defaultConfig = Object.freeze({
    level: "debug",
});
var createLogFn = function (level, context) {
    var adapter = context.config.adapter;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var adapterFn = adapter[level];
        if (typeof adapterFn === "function")
            return adapterFn.apply(void 0, args);
        var output = adapter.format.apply(adapter, __spreadArrays([level, context], args));
        return adapter.output(level, context, output);
    };
};
var validateAdapter = function (adapter) {
    return (typeof adapter.format === "function" && typeof adapter.output === "function");
};
var noop = function () { return undefined; };
var createLogger = function (config, label) {
    var _a = __assign(__assign({}, defaultConfig), config), level = _a.level, adapter = _a.adapter;
    var levelIndex = exports.LogLevels.indexOf(level);
    if (levelIndex === -1)
        throw new Error("Unsupported log level: \"" + config.level + "\"");
    if (!adapter || !validateAdapter(adapter))
        throw new Error("Invalid adapter provided in config");
    var context = { label: label, config: config };
    var api = exports.LogLevels.reduce(function (logger, fnLevel) {
        var ref = logger;
        if (exports.LogLevels.indexOf(fnLevel) >= levelIndex) {
            ref[fnLevel] = createLogFn(fnLevel, context);
        }
        else {
            ref[fnLevel] = noop;
        }
        return ref;
    }, {});
    var createChildContext = function (prefix) {
        var child = typeof label !== "undefined" ? label + "/" + prefix : prefix;
        return exports.createLogger(config, child);
    };
    return Object.assign(createChildContext, api);
};
exports.createLogger = createLogger;
//# sourceMappingURL=loggerFactory.js.map